import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "limit", "offset"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMemo } from 'react';
import { useQuery } from 'react-query';
import api from 'utils/api';
import playlistKey from './queryKeys';
function useFetchMyPlaylistContent(_ref) {
  var id = _ref.id,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 10000 : _ref$limit,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchMyPlaylistContent() {
    return _fetchMyPlaylistContent.apply(this, arguments);
  }
  function _fetchMyPlaylistContent() {
    _fetchMyPlaylistContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('get', "/api/me/playlists/".concat(id, "/contents"), {
              format: 'list',
              limit: limit,
              offset: offset
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchMyPlaylistContent.apply(this, arguments);
  }
  var _useQuery = useQuery(playlistKey.mySinglePlaylistContent(id), fetchMyPlaylistContent, _objectSpread({
      staleTime: 5 * 60 * 1000
    }, queryOptions)),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  var items = useMemo(function () {
    return (data === null || data === void 0 ? void 0 : data.items) || [];
  }, [data === null || data === void 0 ? void 0 : data.items]);
  return _objectSpread({
    items: items,
    total: data === null || data === void 0 ? void 0 : data.total,
    nextOffset: data === null || data === void 0 ? void 0 : data.nextOffset
  }, result);
}
export default useFetchMyPlaylistContent;